import { config } from '../config';

export const initHubspot = () => {
    const { environment } = config;

    let hubspotId;

    if (environment === 'production') {
        hubspotId = '4892644';
    } else if (environment === 'staging') {
        hubspotId = '49642184';
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${hubspotId}.js`;

    document.head.appendChild(script);
};
